import React, { useState, useCallback, useMemo, useEffect } from "react";
import { toast } from "react-toastify";
import {
  Col,
  Card,
  Container,
  CardBody,
  CardHeader,
  Form,
  Row,
} from "reactstrap";
import BreadCrumb from "../../components/common/breadCrumb";
import { getId, getRole } from "../../utils/helpers/custom";
import * as Yup from "yup";
import { useFormik, Formik, Field, ErrorMessage, FieldArray } from "formik";
import TableContainer from "../../components/common/tableContainer";
import { Tooltip as ReactTooltip } from "react-tooltip";
import {
  listTopics,
  addCourse,
  updateCourse,
  deleteCourse,
  deleteTopics,
  listOfAssignCourse,
} from "../../api/itpApi";
import {
  InputPlaceHolder,
  validationMessages,
} from "../../utils/helpers/validationMasseges";
import { Link } from "react-router-dom";
import NoResultsMessage from "../../components/noResultMessage";
import ApproveRejectModal from "../../components/common/approveRejectModal";
import {
  checkStatusCodeSuccess,
  CommonLabel,
  Roles,
} from "../../utils/helpers/common";
import { ItpLabel } from "../../common/constant/Itp";
import BaseButton from "../../components/BaseComponents/BaseButton";
import BaseModal from "../../components/BaseComponents/BaseModal";
import BaseInput from "../../components/BaseComponents/BaseInput";

const ITP = (props) => {
  document.title = ItpLabel.Itp;
  const id = getId();
  const [itplist, setitplist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [assignCourse, setAssignCourse] = useState([]);
  const [payload, setPayload] = useState();
  const [selectedRow, setSelectedRow] = useState(null);

  const listOfTopicsFun = () => {
    setLoading(true);
    listTopics({ ...itplist })
      .then((resp) => {
        setitplist(resp?.data?.data);
      })
      .catch((err) => err)
      .finally(() => {
        setLoading(false);
      });
  };

  const listOfAssignTopicFun = () => {
    setLoading(true);
    listOfAssignCourse({ assignTo: parseInt(id) })
      .then((response) => {
        if (!checkStatusCodeSuccess(response?.data?.statusCode)) {
          setAssignCourse([]);
        } else {
          setAssignCourse(response?.data?.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        return err;
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (role === Roles.Admin || role === Roles.HR) {
      listOfTopicsFun();
    }

    if (role === Roles.Employee || role === Roles.BDE) {
      listOfAssignTopicFun();
    }
  }, []);

  const QueryColumnsEmp = useMemo(() => [
    {
      Header: ItpLabel.CourseName,
      accessor: "course.courseName",
      Cell: (item) => {
        return <div>{item?.cell?.row?.original?.course?.courseName}</div>;
      },
    },
    {
      Header: ItpLabel.NoOfTopics,
      accessor: "course.noOfTopics",
      Cell: (item) => {
        return <div>{item?.cell?.row?.original?.course?.noOfTopics}</div>;
      },
    },
    {
      Header: ItpLabel.Duration,
      accessor: "course.duration",
      Cell: (item) => {
        return <div>{item?.cell?.row?.original?.course?.duration}</div>;
      },
    },
    {
      Header: CommonLabel.Action,
      Cell: (cellProps) => {
        return (
          <div>
            <div className="hstack gap-2">
              <Link
                to={`/itp/${cellProps?.cell?.row?.original?.course?.id}`}
                className="btn btn-sm btn-soft-info edit-list"
                state={{ courseName: cellProps?.cell?.row?.original?.course?.courseName }}
                id={`view-${cellProps?.cell?.row?.index}`}
              >
                <i className="ri-eye-line align-bottom" />
              </Link>
              <ReactTooltip
                place="bottom"
                variant="info"
                content={CommonLabel.View}
                anchorId={`view-${cellProps?.cell?.row?.index}`}
              />
            </div>
          </div>
        );
      },
    },
  ]);

  const QueryColumns = useMemo(() => [
    {
      Header: ItpLabel.CourseName,
      accessor: "courseName",
      filterable: false,
    },
    {
      Header: ItpLabel.NoOfTopics,
      accessor: "noOfTopics",
      filterable: false,
    },
    {
      Header: ItpLabel.Duration,
      accessor: "duration",
      filterable: false,
    },
    {
      Header: CommonLabel.Action,
      Cell: (cellProps) => {
        return (
          <div>
            <div className="hstack gap-2">
              <Link
                className="btn btn-sm btn-soft-info edit-list"
                onClick={() => itpEdit(cellProps.row.original)}
                id={`edit-${cellProps?.row?.index}`}
              >
                <i className="ri-pencil-fill align-bottom" />
              </Link>
              <ReactTooltip
                place="bottom"
                variant="info"
                content={CommonLabel.Update}
                anchorId={`edit-${cellProps?.row?.index}`}
              />
              <Link
                className="btn btn-sm btn-soft-danger edit-list"
                onClick={() => handleDelete(cellProps.row.original?.id)}
                id={`delete-${cellProps?.row?.index}`}
              >
                <i className="ri-delete-bin-5-fill align-bottom" />
              </Link>
              <ReactTooltip
                place="bottom"
                variant="error"
                content={CommonLabel.Delete}
                anchorId={`delete-${cellProps?.row?.index}`}
              />
              <Link
                to={`/itp/${cellProps?.row?.original?.id}`}
                className="btn btn-sm btn-soft-info edit-list"
                id={`view-${cellProps?.row?.index}`}
              >
                <i className="ri-eye-line align-bottom" />
              </Link>
              <ReactTooltip
                place="bottom"
                variant="info"
                content={CommonLabel.View}
                anchorId={`view-${cellProps?.row?.index}`}
              />
            </div>
          </div>
        );
      },
    },
  ]);

  const [todo, setTodo] = useState(null);
  const [modalTodo, setModalTodo] = useState(false);
  const [topic, setRowsData] = useState([]);
  const role = getRole();
  const idUser = parseInt(getId());

  const additp = () => {
    setTodo("");
    setModalTodo(!modalTodo);
    setIsEdit(false);
    setRowsData([]);
    toggle();
  };

  const toggle = useCallback(() => {
    if (modalTodo) {
      setModalTodo(false);
      listTopics({ ...itplist })
        .then((resp) => {
          setitplist(resp?.data?.data);
        })
        .catch((err) => err)
        .finally(() => {
          setLoading(false);
        });
      setTodo(null);
    } else {
      setModalTodo(true);
    }
  }, [modalTodo]);

  //Edit table
  const [isEdit, setIsEdit] = useState(false);
  const itpEdit = useCallback(
    (arg) => {
      const todo = arg;
      setPayload([...(todo?.topic || [])]);

      setTodo({
        courseName: todo.courseName,
        courseId: todo.id,
      });
      setRowsData(todo.topic);
      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      courseName: (todo && todo.courseName) || "",
    },
    validationSchema: Yup.object({
      courseName: Yup.string().required(
        validationMessages.required(ItpLabel.CourseName)
      ),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const newTopic = topic.map((res) => {
          return {
            id: res.id,
            link: res.link,
            topicName: res.topicName,
            hour: res.hour,
          };
        });
        setLoading(true);
        updateCourse({ ...values, courseId: todo.courseId, topic: newTopic })
          .then((response) => {
            if (checkStatusCodeSuccess(response?.data?.statusCode)) {
              toast.success(response?.data?.message);
              listOfTopicsFun();
              setLoading(false);
            }
          })
          .catch((err) => err)
          .finally(() => {
            setLoading(false);
          });
        setModalTodo(false);
        validation.resetForm();
      } else {
        setLoading(true);
        const payload = {
          userId: idUser,
          courseName: values.courseName,
          topic: topic.map(({ topicName, link, hour, remark }) => ({
            topicName,
            link,
            hour,
            remark,
          })),
        };

        addCourse(payload).then((response) => {
          if (checkStatusCodeSuccess(response?.data?.statusCode)) {
            toast.success(response?.data?.message);
            listTopics({ ...itplist }).then((resp) => {
              setitplist(resp.data.data);
              setLoading(false);
            });
          }
        });
      }
      setModalTodo(false);
      validation.resetForm();
      toggle();
    },
  });

  const [deleteId, setDeleteId] = useState();
  const [deleteTopicId, setDeleteTopicId] = useState(undefined);

  // Delete To do
  const [deleteModal, setDeleteModal] = useState(false);
  const [arrayHelpersState, setArrayHelpersState] = useState();
  const [indexState, setIndexState] = useState();

  useEffect(() => {
    if (deleteTopicId !== undefined) {
      deleteTopics({
        courseId: todo?.courseId,
        topic: [{ id: deleteTopicId, isDeleted: true }],
      })
        .then((res) => {
          arrayHelpersState?.remove(indexState);
          setDeleteTopicId(undefined);
        })
        .catch((err) => {
          return err;
        })
        .finally(() => {});
    } else {
      arrayHelpersState?.remove(indexState);
    }
  }, [deleteTopicId, arrayHelpersState, todo?.courseId, indexState]);
  const itpDelete = (id, arrayHelpers, index) => {
    setDeleteTopicId(id);
    setArrayHelpersState(arrayHelpers);
    setIndexState(index);
  };

  const handleDelete = (row) => {
    setSelectedRow({ ...row, action: "to delete this record" });
    setDeleteId(row);
    setDeleteModal(true);
  };

  const handleDeleteTodo = () => {
    setModalLoader(true);
    deleteCourse({ id: deleteId, isDeleted: true }).then((resp) => {
      if (checkStatusCodeSuccess(resp?.data?.statusCode)) {
        setDeleteModal(false);
        setitplist(resp.data.data);
        toast.success(resp.data.message);
        listTopics().then((resp) => {
          setitplist(resp.data.data);
          setLoading(false);
        });
      } else {
        toast.error(resp.data.message);
      }
    }).finally(() => {
      setModalLoader(false);
    });
  };

  const handleSubmit = (values) => {
    setModalLoader(true);
    if (isEdit) {
      updateCourse({ ...values, courseId: todo.courseId })
        .then((response) => {
          if (checkStatusCodeSuccess(response?.data?.statusCode)) {
            toast.success(response?.data?.message);
            listOfTopicsFun();
            setModalTodo(false);
            setLoading(false);
          }
        })
        .catch((err) => err)
        .finally(() => {
          setModalLoader(false);
        });
    } else {
      addCourse({ userId: idUser, ...values }).then((response) => {
        if (checkStatusCodeSuccess(response?.data?.statusCode)) {
          toast.success(response?.data?.message);
          setModalTodo(false);
          listTopics({ ...itplist }).then((resp) => {
            setitplist(resp.data.data);
            setModalLoader(false);
          });
        }
      });
    }

  };

  const validationSchema = Yup.object({
    courseName: Yup.string().required(
      validationMessages.required(ItpLabel.CourseName)
    ),
    topic: Yup.array().of(
      Yup.object().shape({
        topicName: Yup.string().required(
          validationMessages.required(ItpLabel.TopicName)
        ),
        link: Yup.string().nullable().url(validationMessages.url(ItpLabel.URL)),
        hour: Yup.string().required(validationMessages.required(ItpLabel.Hour)),
        remark: Yup.string().nullable(),
      })
    ),
  });

  const dataList =
    (role === Roles.Admin || role === Roles.HR) ? itplist : assignCourse;

  const column =
    role === Roles.Admin || role === Roles.HR ? QueryColumns : QueryColumnsEmp;

  return (
    <React.Fragment>
      <ApproveRejectModal
        show={deleteModal}
        onDeleteClick={() => handleDeleteTodo()}
        onCloseClick={() => setDeleteModal(false)}
        action={selectedRow ? selectedRow.action : ""}
        loader={modalLoader}
      />
      <div className="page-content">
          <Container fluid>
            <BreadCrumb title="ITP" pageTitle="HRMS" />
            <Row className="mb-2">
              <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
                <h5 className="fw-semibold mt-2">{ItpLabel.ItpFullForm}</h5>
              </div>

              <div className="col-auto order-2 order-sm-3 ms-auto">
                <div className="hstack gap-2">
                  {role !== Roles.Employee && (
                    <BaseButton
                      color="primary"
                      type="button"
                      onClick={() => additp()}
                    >
                      + {ItpLabel.NewItp}
                    </BaseButton>
                  )}
                  {role !== Roles.BDE && (
                    <Link to="/itp-project">
                      <BaseButton color="primary" type="button">
                        {ItpLabel.Project}
                      </BaseButton>
                    </Link>
                  )}
                </div>
              </div>
            </Row>
            <Card>
              <CardHeader className="align-items-center d-flex">
                <h4 className="card-title mb-0 flex-grow-1">{ItpLabel.Itp}</h4>
              </CardHeader>
              <CardBody>
                {dataList?.length > 0 || loading ? (
                  <TableContainer
                    columns={column}
                    data={dataList}
                    isAddUserList={false}
                    customPageSize={5}
                    isGlobalFilter={true}
                    tableLoader={loading}
                    divClass="table-responsive table-card mb-1 "
                    tableClass="align-middle table-nowrap "
                    theadClass="table-light text-muted"
                    SearchPlaceholder={CommonLabel.Search}
                  />
                ) : (
                  <NoResultsMessage />
                )}
              </CardBody>
            </Card>
          </Container>
      </div>

      <Formik
        initialValues={{
          courseName: "" || todo?.courseName,
          topic: isEdit
            ? payload
            : [{ topicName: "", remark: "", link: "", hour: "" }],
        }}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        {({
          values,
          handleChange,
          handleBlur,
          isValid,
          errors,
          touched,
          validateForm,
          submitForm,
          setTouched,
        }) => (
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              if (!isValid) {
                handleSubmit(values);
              }
            }}
          >
            <BaseModal
              open={modalTodo}
              size="xl"
              onClose={() => setModalTodo(false)}
              toggle={toggle}
              className="zoomIn"
              title={isEdit ? ItpLabel.UpdateItp : ItpLabel.AddItp}
              bodyClassName="p-4"
              loader={modalLoader}
              submit={() => {
                validateForm().then((formErrors) => {
                  if (Object.keys(formErrors).length > 0) {
                    setTouched({
                      courseName: true,
                      topic: values.topic.map((_, index) => ({
                        topicName: true,
                        remark: true,
                        link: true,
                        hour: true,
                      })),
                    });
                  } else {
                    submitForm();
                  }
                });
              }}
              submitLabel={isEdit ? CommonLabel.Update : CommonLabel.Submit}
              submitLabelColor="primary"
              closeLabel={CommonLabel.Close}
              closeLabelColor="ghost-success"
            >
              <div
                id="task-error-msg"
                className="alert alert-danger py-2"
              ></div>
              <Row className="g-4 mb-3">
                <Col lg={12}>
                  <div className="mb-3">
                    <BaseInput
                      type="text"
                      name="courseName"
                      label={ItpLabel.CourseName}
                      placeholder={InputPlaceHolder(ItpLabel.CourseName)}
                      value={values.courseName}
                      onChange={handleChange}
                      handleBlur={handleBlur}
                      error={errors.courseName}
                      touched={touched.courseName}
                      required
                    />
                  </div>
                </Col>
              </Row>

              <FieldArray name="topic">
                {(arrayHelpers) => (
                  <div>
                    <div
                      className="todo-content position-relative px-4 mx-n4"
                      id="todo-content"
                    >
                      <div className="todo-task" id="todo-task">
                        <div className="table-responsive">
                          <table className="table align-middle position-relative table-nowrap">
                            <thead className="table-active">
                              <tr>
                                <th scope="col" className="required">{ItpLabel.TopicName}
                                </th>
                                <th scope="col">{ItpLabel.Remark}</th>
                                <th scope="col">{ItpLabel.Link}</th>
                                <th scope="col" className="required">{ItpLabel.Hour}</th>
                                <th></th>
                              </tr>
                            </thead>

                            <tbody id="task-list">
                              <BaseButton
                                type="button"
                                color="ghost-success"
                                className="mt-2 custom-css-input-size-button"
                                onClick={() =>
                                  arrayHelpers.push({
                                    topicName: "",
                                    remark: "",
                                    link: "",
                                    hour: "",
                                  })
                                }
                              >
                                <i className="ri-add-line mt-2" />{" "}
                                {ItpLabel.NewTopic}
                              </BaseButton>
                              {values.topic.map((user, index) => (
                                <tr key={index}>
                                  <td>
                                    <BaseInput
                                      type="text"
                                      name={`topic.${index}.topicName`}
                                      id={`topic.${index}.topicName`}
                                      placeholder={InputPlaceHolder(
                                        ItpLabel.TopicName
                                      )}
                                      value={values.topic[index].topicName}
                                      onChange={handleChange}
                                      handleBlur={handleBlur}
                                      error={errors.topic?.[index]?.topicName}
                                      touched={
                                        touched.topic?.[index]?.topicName
                                      }
                                    />
                                  </td>

                                  <td className="custom-css-input-size">
                                    <BaseInput
                                      type="text"
                                      name={`topic.${index}.remark`}
                                      id={`topic.${index}.remark`}
                                      placeholder={InputPlaceHolder(
                                        ItpLabel.Remark
                                      )}
                                      value={values.topic[index].remark}
                                      onChange={handleChange}
                                      handleBlur={handleBlur}
                                      error={errors.topic?.[index]?.remark}
                                      touched={touched.topic?.[index]?.remark}
                                    />
                                  </td>

                                  <td className="custom-css-input-size-link">
                                    <BaseInput
                                      type="text"
                                      name={`topic.${index}.link`}
                                      id={`topic.${index}.link`}
                                      placeholder={InputPlaceHolder(
                                        ItpLabel.Link
                                      )}
                                      value={values.topic[index].link}
                                      onChange={handleChange}
                                      handleBlur={handleBlur}
                                      error={errors.topic?.[index]?.link}
                                      touched={touched.topic?.[index]?.link}
                                    />
                                  </td>

                                  <td className="custom-css-input-size-hour">
                                    <BaseInput
                                      type="number"
                                      name={`topic.${index}.hour`}
                                      id={`topic.${index}.hour`}
                                      placeholder={InputPlaceHolder(
                                        ItpLabel.Hour
                                      )}
                                      value={values.topic[index].hour}
                                      onChange={handleChange}
                                      handleBlur={handleBlur}
                                      error={errors.topic?.[index]?.hour}
                                      touched={touched.topic?.[index]?.hour}
                                    />
                                  </td>

                                  <td>
                                    <Link
                                      type="button"
                                      className="btn btn-sm btn-outline-danger edit-list"
                                      onClick={() =>
                                        itpDelete(user.id, arrayHelpers, index)
                                      }
                                      data-tooltip-id={`delete-${index}`}
                                      data-tooltip-place="bottom"
                                    >
                                      <i className="ri-delete-bin-2-fill"></i>
                                    </Link>
                                    <ReactTooltip
                                      place="bottom"
                                      variant="error"
                                      content={CommonLabel.Delete}
                                      id={`delete-${index}`}
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </FieldArray>
            </BaseModal>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
};

export default ITP;
